/* USE PROTECTION design: behaviour shared by the up-* sections. ES5 on purpose (no build step, same as mf-track.js).
   1. Videos   - ONE video plays at a time on the whole page: the one most in view (owner 2026-10-21: "not everything
                 needs to play at once"). The player below knows every up-* video ([data-u-inview]; [data-u-autoplay],
                 the home hero) and every video another script starts (the PDP gallery's, assets/up-pdp.js). Of those
                 that may play - an up-* one at least a quarter on screen once the page has loaded (the hero once it
                 is also idle), another script's while that script wants it and half of it shows - the one with the
                 largest area on screen plays and every other one is paused: the one playing keeps the place until
                 another one shows 25% more of itself, and on a desktop the one under the mouse wins while the mouse is
                 on it (a row of drop tests plays the tile you point at). Another script's play() takes the place at once; its own pause()
                 gives it up. Nothing plays while a panel (upPanel), the cart drawer or another tab is in front; it
                 resumes when that closes.
                 Reduced motion, Save-Data or a 2G-class connection keep every up-* video on its poster (the hero also
                 on 3G).
                 Nothing downloads before a video plays: the markup holds the file in data-src (on the <video>, or on
                 its <source>s) and every up-* video is preload="none"; the address is set, and load() called, only when
                 the video is the one to play. Of <source data-src media> the ones whose media does not match are
                 dropped first, so a browser that ignores media on <source> plays the same file as every other.
                 (No load() before that: in Chromium an explicit load() overrides preload="none" and downloads the file.)
                 Markup that still carries src on a <source media> (an older copy of a section) is pruned on boot the
                 same way, and re-pointed when it starts if a media-blind browser had already chosen the removed file.
                 A video whose poster sits below the first screen carries data-u-poster instead of poster; it is set
                 when the video (or the sideways row it scrolls in, all its tiles at once) comes within 300px of the
                 screen, and from the first scroll on within 1200px (about two phone screens: a fast fling lands on a
                 drawn poster) - a visitor who never scrolls downloads none of them. Till then the markup gives it a
                 40px copy of the poster as its background (a long jump lands on a blurred picture, never on an empty
                 box). The phone file is the markup's <source media="(max-width: 759px)"> (theme assets <name>-m.mp4).
   2. Panels   - the mockup's .u-panel sheets (menu, devices, search, the PDP sheets, the giveaway sheet ...), below.
   3. Pictures inside closed panels wait: img[data-u-src] / [data-u-srcset] become src / srcset when their panel first
                 opens (upPanel.open; for the cart drawer #mini-cart, its open attribute), and a closed part of an open
                 panel (aria-hidden, e.g. the menu's Collabs page) when the control that shows it (aria-controls) is used. */
(function () {
  var W = window, D = document;
  var reduce = !!(W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var C = W.navigator && W.navigator.connection;
  var et = (C && C.effectiveType) || '';
  var lite = !!(C && C.saveData) || /2g$/.test(et);   /* Save-Data, slow-2g, 2g */
  var IO = 'IntersectionObserver' in W;
  var MIN = 0.25;        /* the share of a video that must be on screen before it may play */
  var tracked = [];      /* the videos the player knows */
  var cur = null;        /* the one that may play */
  var hov = null;        /* the up-* video under the mouse: it wins */
  var timer = 0;
  var loaded = D.readyState === 'complete';
  function each(list, fn) { [].forEach.call(list, fn); }
  function onPage(v) { return D.documentElement.contains(v); }
  function matches(s) {
    var m = s.getAttribute('media');
    if (!m || !W.matchMedia) { return true; }
    try { return W.matchMedia(m).matches; } catch (e) { return true; }
  }

  /* ── which file: older markup with src on <source media> (see the head of this part) ── */
  function pick(v) {
    if (!W.matchMedia || v.readyState > 0) { return; }
    var all = v.querySelectorAll('source[src]');
    var drop = [].filter.call(v.querySelectorAll('source[media][src]'), function (s) { return !matches(s); });
    if (!drop.length || drop.length === all.length) { return; }
    drop.forEach(function (s) { s.parentNode.removeChild(s); });
    v.__upPruned = true;
  }
  /* a pruned video that a media-blind browser had already pointed at a removed source: choose again (load) before it
     plays. A browser that honours media chose the remaining source in the first place, so nothing happens there. */
  function repoint(v) {
    if (!v.__upPruned) { return false; }
    v.__upPruned = false;
    var keep = v.querySelector('source');
    if (!keep || !v.currentSrc || v.currentSrc === keep.src) { return false; }
    try { v.load(); } catch (e) {}
    return true;
  }
  /* the file only now (data-src, see the head of this part) */
  function attach(v) {
    if (v.__upSrc) { return; }
    v.__upSrc = true;
    if (v.hasAttribute('data-src')) { v.setAttribute('src', v.getAttribute('data-src')); v.removeAttribute('data-src'); return; }
    var ss = [].slice.call(v.querySelectorAll('source[data-src]'));
    if (!ss.length) { return; }
    var keep = ss.filter(matches);
    if (!keep.length) { keep = ss.slice(-1); }
    ss.forEach(function (s) {
      if (keep.indexOf(s) < 0) { s.parentNode.removeChild(s); return; }
      s.setAttribute('src', s.getAttribute('data-src')); s.removeAttribute('data-src');
    });
    try { v.load(); } catch (e) {}
  }

  /* ── play / pause, telling this player's own calls from another script's (the events below) ── */
  function run(v) {
    if (!v.paused) { return; }
    attach(v);
    repoint(v);
    v.__upP = 1;
    var p = v.play();
    if (p && p.catch) { p.catch(function () { v.__upP = 0; }); }
  }
  function stop(v) { if (!v.paused) { v.__upS = 1; v.pause(); } }

  /* ── who plays ── */
  function held() {
    var cd = D.getElementById('mini-cart');
    return !!((W.upPanel && W.upPanel.current()) || (cd && cd.hasAttribute('open')) || D.hidden);
  }
  /* an up-* video: a quarter on screen, once ready; another script's: while it wants it and half of it shows (the PDP
     gallery plays a clip from 60% on and pauses it below that, assets/up-pdp.js - half is the IO step just under it) */
  function wants(v) {
    if (!onPage(v)) { return false; }
    return v.__upAuto ? (v.__upR || 0) >= MIN && !!v.__upReady : (v.__upR || 0) >= 0.5 && !!v.__upWant;
  }
  function decide() {
    timer = 0;
    var hold = held(), best = null, top = 0;
    tracked = tracked.filter(onPage);
    if (hov && (!onPage(hov) || (hov.__upR || 0) < MIN)) { hov = null; }   /* the pointed-at one left the screen */
    if (!hold) {
      tracked.forEach(function (v) {
        if (!wants(v)) { return; }
        var s = Math.max(v.__upA || 0, 1) * (v === hov ? 4 : 1) * (v === cur ? 1.25 : 1);
        if (s > top) { best = v; top = s; }
      });
    }
    cur = best;
    tracked.forEach(function (v) { if (v !== best) { stop(v); } });
    if (best) { run(best); }
  }
  /* a short wait, so a fast scroll past a video starts nothing; 0 for a pause */
  function later(ms) { clearTimeout(timer); timer = setTimeout(decide, ms == null ? 200 : ms); }
  var seen = IO ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var r = e.intersectionRect;
      e.target.__upR = e.isIntersecting ? e.intersectionRatio : 0;
      e.target.__upA = e.isIntersecting ? r.width * r.height : 0;
    });
    later();
  }, { threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }) : null;
  function track(v) {
    if (tracked.indexOf(v) > -1) { return; }
    tracked.push(v);
    if (seen) { seen.observe(v); } else { v.__upR = 1; v.__upA = 1; }
  }

  /* another script's play() / pause() ('play' and 'pause' do not bubble: caught on the way down) */
  D.addEventListener('play', function (e) {
    var v = e.target;
    if (!v || v.tagName !== 'VIDEO') { return; }
    if (v.__upP) { v.__upP = 0; return; }
    if (repoint(v)) { var p = v.play(); if (p && p.catch) { p.catch(function () {}); } }
    v.__upWant = true;
    track(v);
    if (v.__upR == null) {   /* not measured yet: its script played it because it is on screen */
      var b = v.getBoundingClientRect();
      v.__upR = 1; v.__upA = Math.max(0, Math.min(b.right, W.innerWidth) - Math.max(b.left, 0)) * Math.max(0, Math.min(b.bottom, W.innerHeight) - Math.max(b.top, 0));
    }
    if (held()) { stop(v); return; }
    cur = v;
    tracked.forEach(function (o) { if (o !== v) { stop(o); } });
  }, true);
  D.addEventListener('pause', function (e) {
    var v = e.target;
    if (!v || v.tagName !== 'VIDEO') { return; }
    if (v.__upS) { v.__upS = 0; return; }
    v.__upWant = false;
    if (v === cur) { cur = null; later(); }
  }, true);
  /* the mouse picks among videos on screen (desktop): the video of the figure under the pointer */
  D.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse' || !e.target || !e.target.closest) { return; }
    var f = e.target.closest('figure, video');
    var v = f && (f.tagName === 'VIDEO' ? f : f.querySelector('video'));
    if (v && v !== hov && v.__upAuto && tracked.indexOf(v) > -1) { hov = v; later(120); }
  });
  /* ... and lets go of it when the pointer leaves that figure (else the last tile pointed at kept its weight after the
     mouse had left the row); the one playing keeps its place as usual */
  D.addEventListener('pointerout', function (e) {
    if (!hov || e.pointerType !== 'mouse' || !e.target) { return; }
    var f = (hov.closest && hov.closest('figure')) || hov;
    if (!f.contains(e.target) || (e.relatedTarget && f.contains(e.relatedTarget))) { return; }
    hov = null; later(120);
  });
  /* a panel, the cart drawer or another tab in front: everything pauses; back: the one in view resumes */
  D.addEventListener('u:panel-open', function () { later(0); });
  D.addEventListener('u:panel-close', function () { later(); });
  D.addEventListener('visibilitychange', function () { later(D.hidden ? 0 : 200); });
  function watchCart() {
    var cd = D.getElementById('mini-cart');
    if (!cd || cd.__upVid || !('MutationObserver' in W)) { return; }
    cd.__upVid = true;
    new MutationObserver(function () { later(cd.hasAttribute('open') ? 0 : 200); }).observe(cd, { attributes: true, attributeFilter: ['open'] });
  }

  /* ── posters below the first screen (data-u-poster, see the head of this part) ── */
  /* the nearest sideways-scrolling row around a video, else the video */
  function rowOf(v) {
    for (var el = v.parentElement, i = 0; el && i < 4; el = el.parentElement, i++) {
      var ox = W.getComputedStyle(el).overflowX;
      if (ox === 'auto' || ox === 'scroll') { return el; }
    }
    return v;
  }
  function posters(box) {
    var list = box.tagName === 'VIDEO' ? [box] : [].slice.call(box.querySelectorAll('video[data-u-poster]'));
    list.forEach(function (v) {
      if (!v.hasAttribute('data-u-poster')) { return; }
      v.setAttribute('poster', v.getAttribute('data-u-poster')); v.removeAttribute('data-u-poster');
    });
  }
  var boxes = [], far = null;
  function reached(es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) { return; }
      near.unobserve(e.target); if (far) { far.unobserve(e.target); }
      posters(e.target);
    });
  }
  var near = IO ? new IntersectionObserver(reached, { rootMargin: '300px 0px' }) : null;
  function widen() {
    W.removeEventListener('scroll', widen);
    if (!IO || far) { return; }
    far = new IntersectionObserver(reached, { rootMargin: '1200px 0px' });
    boxes.forEach(function (b) { if (b.querySelector && (b.hasAttribute('data-u-poster') || b.querySelector('video[data-u-poster]'))) { far.observe(b); } });
  }
  if (IO) { W.addEventListener('scroll', widen, { passive: true }); }

  function ready() { tracked.forEach(function (v) { if (v.__upAuto && !v.__upHero) { v.__upReady = true; } }); later(0); }
  /* the hero: after the load event, when the main thread is free - it never competes with the first paint */
  function idle(fn) {
    var go = function () { if (W.requestIdleCallback) { W.requestIdleCallback(fn, { timeout: 2500 }); } else { setTimeout(fn, 1200); } };
    if (loaded) { go(); } else { W.addEventListener('load', go); }
  }
  function arm(root) {
    root = root || D;
    each(root.querySelectorAll('video'), function (v) { if (v.querySelector('source[media][src]')) { pick(v); } });
    each(root.querySelectorAll('video[data-u-poster]'), function (v) {
      if (!near) { posters(v); return; }
      var box = rowOf(v);
      if (box.hasAttribute('data-u-pbox')) { return; }
      box.setAttribute('data-u-pbox', ''); boxes.push(box); near.observe(box); if (far) { far.observe(box); }
    });
    watchCart();
    if (reduce || lite) { return; }   /* the posters stay (another script's video is still held to one at a time) */
    each(root.querySelectorAll('video[data-u-inview]:not([data-u-armed]), video[data-u-autoplay]:not([data-u-armed])'), function (v) {
      v.setAttribute('data-u-armed', '');
      v.__upAuto = true;
      if (v.hasAttribute('data-u-autoplay')) {
        if (et === '3g') { return; }
        v.__upHero = true;
        idle(function () { v.__upReady = true; later(0); });
      } else if (loaded) { v.__upReady = true; }
      track(v);
    });
    later();
  }
  W.addEventListener('load', function () { loaded = true; ready(); });
  if (D.readyState === 'loading') { D.addEventListener('DOMContentLoaded', function () { arm(); }); } else { arm(); }
  D.addEventListener('shopify:section:load', function (e) { arm(e.target); });
})();

/* Panels (the mockup's .u-panel sheets: menu, search, devices, the PDP sheets ...) and their scrim.
   Any [data-u-open="<id>"] opens the panel with that id - only when that panel is on the page, and a modified click
   (new tab / window) on a LINK is left to the link (a button has nothing else to do, so it always acts); [data-u-close],
   the scrim or Escape closes the open one. A popup that lands above an open panel (the 10% popup #mf-popup, the game
   popup .mfg; both open on a timer) owns the keyboard while it is up: Escape does not close the panel under it, and
   Tab stays in the popup - the game popup's own capture-phase trap moves the focus, #mf-popup has none, so this file
   cycles it there - and the event stops here, so the panel scripts' own traps (up-menu.js, up-search.js) never pull
   the focus back under the popup.
   window.upPanel.open(id) / .close() / .current() for scripts; 'u:panel-open' / 'u:panel-close' (detail.id) on document.
   <html data-u-panel="<id>"> while a panel is open (speed, 2026-10-21): the hook for page-wide rules that follow an open
   panel (scroll lock, the dimmed header). Write them as html[data-u-panel="menu"] body {...}, never as
   html:has(#menu.u-on) body {...}: a :has() on the root is re-checked on every class change and insert anywhere in the
   page (.u-on is toggled by the gallery dots, the floating bar, the menu's sub-pages ...), and each check restyles the
   whole document - measured 0.8 s (home) to 1.9 s (PDP) of main thread in the first 10 s on a mid-range phone.
   Accessibility, for every panel: the openers carry aria-expanded; the panel takes the focus when it opens (a panel
   script may move it on, e.g. up-search.js to its input); Tab / Shift+Tab cycle through what is visible and usable in
   the open panel only - closed parts (aria-hidden, [hidden], inert, the inside of a closed <details>) are skipped, and
   while a part that covers the rest is open (aria-hidden="false", the menu's Collabs page) only that part, which takes
   the focus when it opens and hands it back to its control when it closes; on close the focus goes back to the opener
   (else a visible opener of the panel, else one of the panel the opener sat in) when it was left inside the panel or on
   the page. Note: data-u-src on a non-img element is up-lists.js's (the cards endpoint of a rail / load-more), not this.
   The panel scripts keep their own handlers. up-search.js and up-menu.js (menu, devices) also hand the focus back on
   close: this file's hand-back is scheduled before theirs, so theirs is the one that stays. Their Tab traps stand down:
   this file's Tab handler is the first keydown listener on document (up.js loads in <head>, before them) and stops the
   event once it has moved the focus, so one Tab is never handled twice. */
(function () {
  var W = window, D = document, cur = null, from = null;
  var FOCUSABLE = 'a[href], area[href], button, input:not([type="hidden"]), select, textarea, summary, iframe, [tabindex], [contenteditable="true"]';
  function scrim() { var s = D.querySelector('.u-scrim'); if (!s) { s = D.createElement('div'); s.className = 'u-scrim'; D.body.appendChild(s); s.addEventListener('click', close); } return s; }
  /* a modified click (new tab / window) on a link opener / closer is the link's; on a button it is a plain click */
  function modified(e, el) {
    return !!(el && el.tagName === 'A' && el.hasAttribute('href') && (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey));
  }
  /* a popup above the panels is up: sections/mf-popup.liquid (#mf-popup, [hidden] while closed) and
     assets/mf-popup-game.js (.mfg, [hidden] while closed; its own capture-phase keydown handles Tab and Escape) */
  function above() {
    var x = D.querySelectorAll('#mf-popup:not([hidden]), .mfg:not([hidden])');
    for (var i = 0; i < x.length; i++) { if (x[i].getClientRects().length) { return x[i]; } }
    return null;
  }
  function openers(id) { return D.querySelectorAll('[data-u-open="' + id + '"]'); }
  function expanded(id, on) { [].forEach.call(openers(id), function (o) { o.setAttribute('aria-expanded', on ? 'true' : 'false'); }); }
  function initOpeners(root) {
    [].forEach.call((root || D).querySelectorAll('[data-u-open]:not([aria-expanded])'), function (o) { o.setAttribute('aria-expanded', 'false'); });
  }
  function visible(el) { return !!el && D.documentElement.contains(el) && el.getClientRects().length > 0 && !el.closest('.u-panel:not(.u-on)'); }
  function firstVisible(id) { var t = null; [].forEach.call(openers(id), function (o) { if (!t && visible(o)) { t = o; } }); return t; }
  /* what Tab may land on inside the open panel p */
  function usable(el, p) {
    if (el.disabled || el.tabIndex < 0 || el.closest('[hidden], [inert]')) { return false; }
    var h = el.closest('[aria-hidden="true"]');
    if (h && p.contains(h)) { return false; }
    if (el.checkVisibility) { return el.checkVisibility({ checkVisibilityCSS: true, visibilityProperty: true }); }
    if (!el.getClientRects().length || W.getComputedStyle(el).visibility === 'hidden') { return false; }
    var d = el.closest('details:not([open])');
    return !d || (el.tagName === 'SUMMARY' && el.parentNode === d);
  }
  /* an open part of the panel that covers the rest (a sub-page toggled through aria-hidden, e.g. the menu's Collabs page):
     while it is open, Tab stays in it */
  function openPart(p) { var x = p.querySelectorAll('[aria-hidden="false"]'); return x.length ? x[x.length - 1] : null; }
  function stops(p) {
    var root = openPart(p) || p;
    return [].filter.call(root.querySelectorAll(FOCUSABLE), function (el) { return usable(el, p); });
  }
  /* after a click inside the open panel: a part that just opened takes the focus (its first stop); a part that just
     closed gives it back to the control that opened it */
  var partFrom = null;
  function settle(p) {
    if (cur !== p) { return; }
    var part = openPart(p), a = D.activeElement, s;
    if (part) { if (!part.contains(a)) { s = stops(p); if (s.length) { try { s[0].focus({ preventScroll: true }); } catch (e) {} } } return; }
    var lost = !a || a === D.body || !!(a.closest('[aria-hidden="true"]') && p.contains(a.closest('[aria-hidden="true"]')));
    if (lost) { try { (partFrom && D.documentElement.contains(partFrom) && usable(partFrom, p) ? partFrom : p).focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ── pictures that wait for their panel (data-u-src / data-u-srcset) ── */
  function reveal(root, skipClosedParts) {
    if (!root || !root.querySelectorAll) { return; }
    [].forEach.call(root.querySelectorAll('img[data-u-src], img[data-u-srcset], source[data-u-srcset]'), function (el) {
      if (skipClosedParts) { var h = el.closest('[aria-hidden="true"]'); if (h && h !== root && root.contains(h)) { return; } }
      var ss = el.getAttribute('data-u-srcset'), s = el.getAttribute('data-u-src');
      if (ss) { el.setAttribute('srcset', ss); el.removeAttribute('data-u-srcset'); }
      if (s) { el.setAttribute('src', s); el.removeAttribute('data-u-src'); }
    });
  }
  /* the cart drawer (Focal <cart-drawer id="mini-cart">, opened through its open attribute, re-rendered by theme.js on
     every cart:refresh): its pictures come with its first opening and, from then on, with every re-render */
  function watchCart() {
    var cd = D.getElementById('mini-cart');
    if (!cd || cd.__upWatch) { return; }
    cd.__upWatch = true;
    var seen = false;
    var check = function () { if (cd.hasAttribute('open')) { seen = true; } if (seen) { reveal(cd); } };
    if ('MutationObserver' in W) { new MutationObserver(check).observe(cd, { attributes: true, attributeFilter: ['open'], childList: true }); }
    else { seen = true; }
    check();
  }

  function open(id, opener) {
    var p = D.getElementById(id); if (!p) { return; }
    var a = D.activeElement;
    if (cur && cur !== p) { close(); }
    if (cur !== p) { from = opener || (a && a !== D.body && !p.contains(a) ? a : null); }
    cur = p; partFrom = null; p.classList.add('u-on'); p.setAttribute('aria-hidden', 'false');
    D.documentElement.setAttribute('data-u-panel', id);
    scrim().classList.add('u-on'); D.body.classList.add('u-lock');
    expanded(id, true);
    if (!p.hasAttribute('tabindex')) { p.setAttribute('tabindex', '-1'); }
    try { p.focus({ preventScroll: true }); } catch (e) {}
    D.dispatchEvent(new CustomEvent('u:panel-open', { detail: { id: id } }));
    reveal(p, true);
  }
  function close() {
    if (!cur) { return; }
    var p = cur, id = p.id, a = D.activeElement, back = from;
    var refocus = !a || a === D.body || p.contains(a);
    p.classList.remove('u-on'); p.setAttribute('aria-hidden', 'true'); cur = null; from = null;
    D.documentElement.removeAttribute('data-u-panel');
    scrim().classList.remove('u-on'); D.body.classList.remove('u-lock');
    expanded(id, false);
    /* the focus back once the close has settled: a panel opened next keeps it, a panel script that moved it wins */
    if (refocus) {
      setTimeout(function () {
        if (cur) { return; }
        var now = D.activeElement;
        if (now && now !== D.body && !p.contains(now)) { return; }
        var host = back && back.closest ? back.closest('.u-panel') : null;
        var t = visible(back) ? back : (firstVisible(id) || (host && host.id ? firstVisible(host.id) : null));
        if (t) { try { t.focus({ preventScroll: true }); } catch (e) {} }
      }, 0);
    }
    D.dispatchEvent(new CustomEvent('u:panel-close', { detail: { id: id } }));
  }
  W.upPanel = { open: function (id) { open(id, null); }, close: close, current: function () { return cur && cur.id; } };

  D.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) { return; }
    var o = t.closest('[data-u-open]');
    if (o) {
      var id = o.getAttribute('data-u-open');
      if (!id || !D.getElementById(id) || modified(e, o)) { return; }
      e.preventDefault(); open(id, o); return;
    }
    var x = t.closest('[data-u-close]');
    if (x) {
      if (!cur || modified(e, x)) { return; }
      e.preventDefault(); close(); return;
    }
    /* a control inside the open panel that shows a closed part of it (aria-controls): that part's pictures now */
    var c = cur ? t.closest('[aria-controls]') : null;
    if (c && cur.contains(c)) { var part = D.getElementById(c.getAttribute('aria-controls')); if (part && cur.contains(part)) { reveal(part); partFrom = c; } }
    if (cur && cur.contains(t)) { var host = cur; setTimeout(function () { settle(host); }, 0); }
  });
  D.addEventListener('keydown', function (e) {
    if (!cur) { return; }
    /* a popup above the open panel owns Tab and Escape (see the head of this part) */
    var top = (e.key === 'Tab' || e.key === 'Escape') ? above() : null;
    if (top) {
      if (e.key === 'Tab' && !e.defaultPrevented && !(e.ctrlKey || e.metaKey)) {
        var ps = [].filter.call(top.querySelectorAll(FOCUSABLE), function (el) { return usable(el, top); });
        var pi = ps.indexOf(D.activeElement);
        e.preventDefault();
        if (ps.length) { try { ps[pi < 0 ? (e.shiftKey ? ps.length - 1 : 0) : (pi + (e.shiftKey ? ps.length - 1 : 1)) % ps.length].focus(); } catch (x0) {} }
      }
      if (e.stopImmediatePropagation) { e.stopImmediatePropagation(); }
      return;
    }
    if (e.defaultPrevented) { return; }
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab' || e.ctrlKey || e.metaKey) { return; }
    var list = stops(cur), a = D.activeElement, i = list.indexOf(a), n = null, k;
    e.preventDefault();
    if (e.stopImmediatePropagation) { e.stopImmediatePropagation(); }
    if (!list.length) { try { cur.focus({ preventScroll: true }); } catch (x) {} return; }
    if (i > -1) { n = list[(i + (e.shiftKey ? list.length - 1 : 1)) % list.length]; }
    else if (a && a !== cur && cur.contains(a)) {
      /* on a stop the list skips: the next usable one after it (the last one before it with Shift), in document order */
      for (k = 0; k < list.length; k++) {
        var after = !!(a.compareDocumentPosition(list[k]) & 4);
        if (!e.shiftKey && after) { n = list[k]; break; }
        if (e.shiftKey && !after) { n = list[k]; }
      }
    }
    if (!n) { n = e.shiftKey ? list[list.length - 1] : list[0]; }
    try { n.focus(); } catch (x) {}
  });
  function boot() { initOpeners(); watchCart(); }
  if (D.readyState === 'loading') { D.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  D.addEventListener('shopify:section:load', function (e) { initOpeners(e.target); watchCart(); });
})();
